<template>
    <div>
        <hero/>
        <a id="services" class="navbar-pagelink"/>
        <services/>
        <a id="clients" class="navbar-pagelink"/>
        <clients/>
        <a id="about-me" class="navbar-pagelink"/>
        <about/>
    </div>
</template>

<script>
import Hero from "./components/Hero.vue"
import Services from "./components/Services.vue"
import Clients from "./components/Clients.vue"
import About from "./components/About.vue"
import Contact from "./components/Contact/Contact.vue"

export default {
    components: {
        Hero,
        Services,
        Clients,
        About
    }
}
</script>